<h2 mat-dialog-title></h2>
<mat-dialog-content class="mat-typography">
    <img [src]="imgData.imgUrl" style="width: 100%; height: 100%" alt="" />
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-button mat-dialog-close>Close</button>
</mat-dialog-actions>
